/// <reference path="../../../Scripts/typings/angularjs/angular.d.ts" />
/// <reference path="../../_envngapp.ts" />
var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Components;
        (function (Components) {
            var BaseComponent = /** @class */ (function () {
                function BaseComponent() {
                    this.controllerAs = "vm";
                }
                return BaseComponent;
            }());
            Components.BaseComponent = BaseComponent;
        })(Components = Core.Components || (Core.Components = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=basecomponent.js.map